import { CHOICES_PANEL } from 'apps/studio/components/settings/fields/Base/choices'
import { HashIcon } from '@gocanvas/gcds/icons'

const dropdownOptions = [
  { 
    value: [
      { position: 0, text: 'Pass' }, 
      { position: 1, text: 'Fail' }
    ], 
    label: 'Pass, Fail'
  },
  { 
    value: [
      { position: 0, text: 'Pass' }, 
      { position: 1, text: 'Fail' }, 
      { position: 2, text: 'N/A' }
    ], 
    label: 'Pass, Fail, N/A'
  },
  { 
    value: [
      { position: 0, text: 'Yes' }, 
      { position: 1, text: 'No' }
    ], 
    label: 'Yes, No'
  },
  { 
    value: [
      { position: 0, text: 'Yes'}, 
      { position: 1, text: 'No' }, 
      { position: 2, text: 'N/A' }
    ], 
    label: 'Yes, No, N/A'
  },
  { 
    value: [
      { position: 0, text: 'Compliant' }, 
      { position: 1, text: 'Non-compliant' }
    ], 
    label: 'Compliant, Non-compliant'
  },
  { 
    value: [
      { position: 0, text: 'Compliant'}, 
      { position: 1, text: 'Non-compliant' }, 
      { position: 2, text: 'N/A' }
    ], 
    label: 'Compliant, Non-compliant, N/A'
  },
]

const PassFailSelect = {
  label: 'Choices',
  settingType: 'selectInput',
  property: 'entry_values',
  choices: dropdownOptions,
  checkEntryValue: true,
  settings: [],
}

const PassFailSettings = [
  PassFailSelect,
]

export const PassFailChoicesPanel = {
  label: CHOICES_PANEL,
  icon: HashIcon,
  settings: PassFailSettings,
}
